import gql from 'graphql-tag';

export const CREATE_SETUP_INTENT = gql`
  mutation CreateSetupIntent($accountId: Int!) {
    createSetupIntent(
      accountId: $accountId
      achMicrodepositVerification: false
    ) {
      stripeClientSecret
    }
  }
`;

export const mockSetupIntent = {
  createSetupIntent: {
    stripeClientSecret: 'top_secret',
  },
};
